// src/components/Layouts/BookingVehicleInfoCard/MobileFooter.tsx
import React from "react";
import { Button } from "@mui/material";
import { FcInfo } from "react-icons/fc";
import { IoCloseCircleSharp } from "react-icons/io5";
import { LoadScript, GoogleMap, Marker } from "@react-google-maps/api";
import { formatPriceWithCurrencySymbol } from "../../../helpers/getPriceWithCurrencySymbol";
import BookingGetters from "../../../store/onlineBooking/getters";
import { VehicleSpecsCardProps } from "./BookingVehicleInfoCard.props";

interface MobileFooterProps {
  isDesktop: boolean;
  istabletScreen: boolean;
  isSmallScreen: boolean;
  isIphoneScreen: boolean;
  totalPrice: number;
  totalPricePerDay: number;
  VehicleDetails: {
    dealerName: string;
    locationDescriptionName: string;
  };
  translate: (key: string) => string;
  showTechnicalSheet: boolean;
  setShowTechnicalSheet: (show: boolean) => void;
  showMap: boolean;
  setShowMap: (show: boolean) => void;
  vehicleParameters: any[];
  handleMapClick: (event: React.MouseEvent) => void;
  appSettings: {
    googleMapApiKey?: string;
  };
  latitude: number;
  longitude: number;
  mapContainerStyle: React.CSSProperties;
  mapOptions: {
    disableDefaultUI: boolean;
    zoomControl: boolean;
  };
  BookButton: React.FC;
  hideTechnicalSheet: () => void;
}

export const MobileFooter: React.FC<MobileFooterProps> = ({
  isDesktop,
  istabletScreen,
  isSmallScreen,
  isIphoneScreen,
  totalPrice,
  totalPricePerDay,
  VehicleDetails,
  translate,
  showTechnicalSheet,
  setShowTechnicalSheet,
  showMap,
  setShowMap,
  vehicleParameters,
  handleMapClick,
  appSettings,
  latitude,
  longitude,
  mapContainerStyle,
  mapOptions,
  BookButton,
  hideTechnicalSheet,
}) => {
  const amountDetails = formatPriceWithCurrencySymbol(
    BookingGetters.getCurrency(),
    totalPrice
  );

  const amountDetailsPerDay = formatPriceWithCurrencySymbol(
    BookingGetters.getCurrency(),
    totalPricePerDay
  );

  return (
    <footer
      className="gap-2 box-border mt-4"
      style={
        isDesktop
          ? { height: "131px", backgroundColor: "#000000" }
          : istabletScreen
          ? { height: "146px", backgroundColor: "#000000" }
          : { backgroundColor: "#000000" }
      }
    >
      <div className="flex flex-row justify-between mt-4">
        <span
          className="total-price md:text-md text-sm text-[#FFFFFF] whitespace-nowrap font-normal flex flex-col"
          style={{
            fontFamily: "MBCorpoSText-Regular-Web-new",
            fontSize: "15px",
            fontWeight: "100px",
            marginLeft: "4%",
          }}
        >
          <span className={isIphoneScreen ? "ml-[-50%]" : "ml-[-50%]"}>
            {VehicleDetails.dealerName}
          </span>
          <span className="ml-[-2px]">
            <span
              className="total-price md:text-md text-sm text-[#FFFFFF] whitespace-nowrap font-normal"
              style={{
                fontFamily: "MBCorpoSText-Regular-Web-new",
                fontSize: "15px",
                fontWeight: "100px",
              }}
            >
              {VehicleDetails.locationDescriptionName}
            </span>
            <Button onClick={hideTechnicalSheet}>
              <p className="text-md capitalize" style={{ color: "#0078D6" }}>
                <FcInfo className="h-[20px] w-[20px]" />
              </p>
            </Button>
          </span>
        </span>

        <span
          className="total-price md:text-md text-sm text-[#FFFFFF] whitespace-nowrap font-normal"
          style={{
            fontFamily: "MBCorpoATextCond-Regular-Web",
            marginRight: "3%",
            fontSize: "20px",
          }}
        >
          <span
            className="md:text-md text-md"
            style={{
              fontFamily: "MBCorpoSText-Regular-Web-new",
              fontSize: "17px",
              fontWeight: "100",
            }}
          >
            <p
              className="whitespace-nowrap text-[#FFFFFF]"
              style={{ marginBottom: isSmallScreen ? "7px" : "" }}
            >
              {amountDetailsPerDay.price + amountDetailsPerDay.symbol}
              <span>{translate("/per day")}</span>
            </p>
          </span>
          <span className="ml-[-9%]">
            <span>{translate("Total") + ":  "}</span>
            <span>{amountDetails.price}</span>
            <span>{amountDetails.symbol + " "}</span>
          </span>
        </span>
      </div>

      {showTechnicalSheet && (
        <div style={{ marginTop: isSmallScreen ? "26px" : "" }}>
          <span
            className="total-price md:text-md text-sm text-[#FFFFFF] whitespace-nowrap font-normal"
            style={{
              fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
              fontSize: "20px",
              color: "white",
            }}
          >
            <span
              className="text-white"
              style={{
                float: "left",
                marginLeft: isIphoneScreen ? "15px" : "14px",
                fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                fontSize: isSmallScreen ? "22px" : "",
              }}
            >
              {translate("Technical sheet")}
            </span>
            <span
              style={{ float: "right", marginRight: "17px" }}
              onClick={() => setShowTechnicalSheet(false)}
            >
              <IoCloseCircleSharp />
            </span>
            <br />
          </span>

          <div className="flex items-center mt-[1%] ml-[4%] mb-[4%]">
            <span
              className="total-price md:text-md text-sm text-[#FFFFFF] whitespace-nowrap font-normal"
              style={{
                fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                fontSize: "20px",
                color: "white",
              }}
            >
              {VehicleDetails.locationDescriptionName}
            </span>
          </div>

          <div className="grid grid-cols-3 gap-6 text-white">
            {vehicleParameters?.map(
              (spec, index) =>
                spec && <VehicleSpecsCardFooter key={index} {...spec} />
            )}
          </div>
        </div>
      )}

      {showMap && (
        <div className="mt-[15%]">
          <span
            className="total-price md:text-md text-sm text-[#FFFFFF] whitespace-nowrap font-normal"
            style={{
              fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
              fontSize: "20px",
              color: "white",
            }}
          >
            <span style={{ float: "left", marginLeft: "18px" }}>
              {VehicleDetails.dealerName}
            </span>
            <span
              style={{ float: "right", marginRight: "17px" }}
              onClick={() => setShowMap(false)}
            >
              <IoCloseCircleSharp />
            </span>
            <br />

            <div className="flex items-center mt-[1%] ml-[5%] mb-[4%]">
              <span
                className="total-price md:text-md text-sm text-[#FFFFFF] whitespace-nowrap font-normal"
                style={{
                  fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                  fontSize: "20px",
                  color: "white",
                }}
              >
                {VehicleDetails.locationDescriptionName}
              </span>
            </div>

            <div style={{ flex: "2" }} onClick={handleMapClick}>
              <LoadScript googleMapsApiKey={appSettings?.googleMapApiKey}>
                <GoogleMap
                  mapContainerStyle={mapContainerStyle}
                  center={{ lat: latitude, lng: longitude }}
                  zoom={12}
                  options={mapOptions}
                  onClick={handleMapClick}
                >
                  <Marker
                    position={{ lat: latitude, lng: longitude }}
                    title="Vehicle Location"
                  />
                </GoogleMap>
              </LoadScript>
            </div>
          </span>
        </div>
      )}

      <div
        className="w-[95%] md:w-full justify-center"
        style={{ marginTop: "2%", marginBottom: "2%" }}
      >
        <BookButton />
      </div>
    </footer>
  );
};

function VehicleSpecsCardFooter({ iconUrl, name }: VehicleSpecsCardProps) {
  const colonIndex = name.indexOf(":") + 1;
  const displayName = colonIndex !== -1 ? name.slice(colonIndex) : name;

  return (
    <span className="flex flex-col p-2 gap-1">
      <span className="w-full flex flex-col items-center p-4">
        {iconUrl && (
          <img
            className="h-[22px] w-[32.42px] mb-2"
            style={{ filter: "invert(100%) brightness(200%)" }}
            src={iconUrl}
            alt={name}
          />
        )}
      </span>
      <span
        className="font-light text-white text-center"
        style={{
          fontSize: "14px",
          fontFamily: "MBCorpoSText-Regular-Web-new",
        }}
      >
        {displayName}
      </span>
    </span>
  );
}
